<script lang="ts">
	export let text: string;
</script>

<div class="text-2xl text-center-- font-bold">{text}</div>
